import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { LectureSearch, LectureAndChannelList, BottomBtn, LectureListCount } from '../../components/liveroomLecturer'
import { Page, WKError } from '../../components'
import * as liveroomSetAct from '../../actions/liveroomSettingLecture'
import { isLZWKAPP, judgeAPPVersion } from '../../utils'


class LecturesPage extends React.Component {
    componentDidMount() {
        let {type} = this.props.params;
        if (type === 'lecture'){
            document.title = '课程管理'
        }else {
            document.title = '专栏管理'
        }
    }
    componentWillUnmount () {
        this.props.setLiveroomSettingLectureInit()
    }
    onClickAdd (type, liveroomId) {
        if (type === 'lecture') {
            if (isLZWKAPP() && judgeAPPVersion(470)) {
                location.assign(`lizhiweike://create_lecture?liveroom_id=${liveroomId}`)
            } else {
                location.assign(`/liveroom/${liveroomId}/lecture/create`)
            }
            // window.location = Config.MAIN_URL + `/lecture/add?liveroom_id=${liveroomId}`
        } else {
            if (isLZWKAPP() && judgeAPPVersion(480)) {
                location.assign(`lizhiweike://create_channel?liveroom_id=${liveroomId}`)
            } else {
                location.assign(`/liveroom/${liveroomId}/channel/create`)
            }
            // window.location = Config.MAIN_URL + `/liveroom/add_channel?liveroom_id=${liveroomId}`
        }
    }
    getTypeText(type) {
        return type === 'lecture' ? '课程' : '专栏'
    }
    render() {
        const { type, liveroom_id } = this.props.params
        if (this.props.error.isError) {
            return <div style={{background: '#fff', position: 'fixed', width: '100%', height: '100%'}}>
                <WKError />
            </div>
        }
        return (
            <div className="liveroom-setting-lecture">
                <Page>
                    <LectureSearch type={type} liveroomId={liveroom_id} />
                    <LectureListCount typeText={this.getTypeText(type)} type={type} />
                    <LectureAndChannelList type={type} liveroomId={liveroom_id} />
                    <BottomBtn btnContent={{ text: `添加新${this.getTypeText(type)}`, method: e => this.onClickAdd(type, liveroom_id) }} />
                    { this.props.error.isError && <WKError /> }
                </Page>
            </div>
        )
    }
}


export default connect(state => ({
    error: state.liveroomSettingLecture.error,
}), dispatch => bindActionCreators({ ...liveroomSetAct }, dispatch))(LecturesPage)



// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/LecturesPage.js